module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/twoPhones_2x.1735712.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/twoPhones_2x.png
// module id = K655
// module chunks = 41